import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Danny Morton',
    title: "Developer and Problem Solver",
    desciption:" I am a dedicated and results-driven professional with a passion for leveraging technology to solve complex problems. With a strong foundation in software development and project management, I excel at delivering innovative solutions that drive efficiency and enhance user experiences. My expertise spans various programming languages, frameworks, and tools, allowing me to adapt quickly to new challenges and environments. I thrive in collaborative settings, where I can contribute my skills to achieve shared goals and exceed expectations.",
    image: 'https://github.com/dmorton714/port_site/blob/main/src/assets/png/OI000001.JPG?raw=true',
    resumePdf: resume
}
